var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 203,
    viewBox: "0 0 1439 203",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30.1875L60 35.2188C120 40.25 240 50.3125 360 80.5C480 110.688 600 161 720 161C840 161 960 110.688 1080 80.5C1200 50.3125 1320 40.25 1380 35.2188L1440 30.1875V0H1380C1320 0 1200 0 1080 0C960 0 840 0 720 0C600 0 480 0 360 0C240 0 120 0 60 0H0V30.1875Z",
    fill: "#FABC05"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 101H60C120 84.0833 240 74.4333 360 60.9C480 47.3667 600 54.1333 720 74.4333C840 94.7333 960 128.567 1080 152.25C1200 175.933 1320 189.467 1380 196.233L1440 203V0H1380C1320 0 1200 0 1080 0C960 0 840 0 720 0C600 0 480 0 360 0C240 0 120 0 60 0H0V101Z",
    fill: "#E94436"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 102.975L80.4 105.426C159.6 107.878 320.4 112.782 480 95.6194C639.6 78.4569 800.4 39.2285 960 19.6142C1119.6 0 1280.4 0 1359.6 0H1440H1359.6C1280.4 0 1119.6 0 960 0C800.4 0 639.6 0 480 0C320.4 0 159.6 0 80.4 0H0V102.975Z",
    fill: "#109D58"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamBg);
export default __webpack_public_path__ + "static/media/Team-bg.508307fe1b6142dff8474522266e6fcf.svg";
export { ForwardRef as ReactComponent };